import { useMemo } from 'react'
import InsightViewOption from 'enums/InsightViewOption'
import { SocialWebStoryScopeWidget as SocialWebStoryScopeWidgetType } from 'schemas/SocialWebStoryScopeWidgetSchema'
import {
  generateSentimentsStrategy,
  generateGendersStrategy,
  generateTermsInsightStrategy,
  generateHashtagsInsightStrategy,
  generateBrandsInsightStrategy,
  generatePeopleInsightStrategy,
  generateEmojiInsightStrategy,
  generateThingsInsightStrategy
} from 'utils/insightModal/strategy/searchFilterComposing'
import LevelOneType from 'enums/LevelOneType'
import { SelectedInsight } from '../types'

const useSearchFilterComposingStrategies = (
  widgetSetting: SocialWebStoryScopeWidgetType,
  selectedInsights: SelectedInsight[]
) => {
  const { levelOneType, viewOption } = widgetSetting

  const levelOneSearchFilterComposingStrategy = useMemo(() => {
    switch (levelOneType) {
      case LevelOneType.SENTIMENT:
      case LevelOneType.SENTIMENT_WO_NEUTRAL:
        return generateSentimentsStrategy()
      case LevelOneType.GENDER:
      case LevelOneType.GENDER_WO_UNKNOWN:
        return generateGendersStrategy()
      case LevelOneType.NONE:
        return undefined
      default:
        throw new Error(`Unsupported level one type: ${levelOneType}`)
    }
  }, [levelOneType])

  const levelTwoSearchFilterComposingStrategy = useMemo(() => {
    switch (viewOption) {
      case InsightViewOption.TERMS:
        return generateTermsInsightStrategy()
      case InsightViewOption.HASHTAGS:
        return generateHashtagsInsightStrategy()
      case InsightViewOption.BRANDS:
        return generateBrandsInsightStrategy()
      case InsightViewOption.PEOPLE:
        return generatePeopleInsightStrategy()
      case InsightViewOption.EMOJIS_GROUP:
      case InsightViewOption.EMOJIS_EMOTION:
      case InsightViewOption.EMOJIS_EMOJI:
        return generateEmojiInsightStrategy()
      case InsightViewOption.THINGS:
        return generateThingsInsightStrategy()
      default:
        throw new Error(`Unsupported view option: ${viewOption}`)
    }
  }, [viewOption])

  const isLevelTwoSelectedInsight = selectedInsights[0]?.levelOneFilter !== undefined
  return [
    ...(levelOneSearchFilterComposingStrategy ? [levelOneSearchFilterComposingStrategy] : []),
    ...(isLevelTwoSelectedInsight ? [levelTwoSearchFilterComposingStrategy] : [])
  ]
}

export default useSearchFilterComposingStrategies
